import React, { useContext } from 'react';
import classnames from 'classnames';

import Context from "../context/context";


const NavItem = props => {
  const {filterNav, setFilterNav, setNavStatus, activeFilters} = useContext(Context);
  const {widget} = props;


  let filter_count = 0;
  if (typeof widget.filters != "undefined"){
    if (widget.filters[0].name == "calendar"){
      if (activeFilters[widget.filters[0].name].value[0] != false){
        filter_count = 1;
      }
    } else {
      filter_count = activeFilters[widget.filters[0].name].value.length;
    }
  }


  const toggleFilterNav = () => {
    const body = document.querySelector('body');
    let any_filters_open = false;

    let updatedFilterNav = [...filterNav]
    updatedFilterNav.map((nav, i) => {
      if (Object.keys(nav).length != 0 && nav.constructor === Object) {
        if (nav.id == widget.id){
          nav.open =  !widget.open;
        } else {
          nav.open = false;
        }

        if (nav.open) {
          any_filters_open = true;
        }
      }
    })

    if (any_filters_open) {
      body.classList.add('filters-open');
      setNavStatus(true);
    } else {
      body.classList.remove('filters-open');
      setNavStatus(false);

    }

    setFilterNav(updatedFilterNav)
  }

  if (widget.title != "Search"){
    return (
      <>
      <div
        className={classnames('filter-section-trigger filter-nav-item ', {
          open: widget.open
        })}
        onClick={() => toggleFilterNav()}
      >
      <div className="filter-nav-item-top">
        <div className="filter-trigger-name  filter-nav-title font-title font-l">{widget.title}</div>
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15" fill="none">
          <path d="M3 2.5L9.42857 7.5L3 12.5" stroke="black" strokeWidth="3" strokeLinecap="square"/>
        </svg>
        <span aria-hidden="true" className="sr-only"> (</span>
        <span
        className={classnames('filter-count', {
          active: filter_count > 0
        })}>{filter_count}</span>
        <span className="sr-only" aria-hidden="true"> filters selected)</span>

      </div>


      </div>
      </>
    )
  } else {

  }

}

export default NavItem;
